import { render, staticRenderFns } from "./ExteriorAttentionDetailBottom.vue?vue&type=template&id=1b0dc09f&scoped=true&"
import script from "./ExteriorAttentionDetailBottom.vue?vue&type=script&lang=js&"
export * from "./ExteriorAttentionDetailBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dc09f",
  null
  
)

export default component.exports